import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'crop'
})
export class CropPipe implements PipeTransform {

  transform(value: string, limit: number): unknown {
    return value.length > limit ? value.substring(0, limit).trim() + '...' : value;
  }

}
